import React, { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import Pageinfo from "../Alert/Pageinfo";
import InputField from "../input-field";
import Tippy from "@tippyjs/react";
import store from "../../redux/store";

function CustomeModal({
  type,
  title,
  content,
  onDelete,
  onClick,
  onCancel,
  buttonText,
}) {
  const closeButtonRef = useRef(null);
  const okButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  const confirmButtonRef = useRef(null);
  const copyButtonRef = useRef(null);
  const copyButtonIconRef = useRef(null);
  const [showCopiedButtonLabel, setShowCopiedButtonLabel] = useState(false);
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);

  useEffect(() => {
    const closeButton = closeButtonRef.current;
    const okButton = okButtonRef.current;
    const deleteButton = deleteButtonRef.current;
    const confirmButton = confirmButtonRef.current;
    const copyButton = copyButtonRef.current;

    if (closeButton && buttonText === "Yes") {
      onCancel
        ? closeButton.addEventListener("click", handleNo)
        : closeButton.addEventListener("click", handleClose);
    } else if (closeButton) {
      onCancel
        ? closeButton.addEventListener("click", handleCancel)
        : closeButton.addEventListener("click", handleClose);
    }

    if (okButton) {
      onClick
        ? okButton.addEventListener("click", handleClick)
        : okButton.addEventListener("click", handleClose);
    }

    if (confirmButton) {
      onClick
        ? confirmButton.addEventListener("click", handleClick)
        : confirmButton.addEventListener("click", handleClose);
    }

    if (deleteButton) {
      deleteButton.addEventListener("click", handleDelete);
    }

    if (copyButton) {
      copyButton.addEventListener("click", handleClick);
    }

    return () => {
      if (closeButton) {
        closeButton.removeEventListener("click", handleClose);
      }

      if (okButton) {
        okButton.removeEventListener("click", handleClose);
      }

      if (deleteButton) {
        deleteButton.removeEventListener("click", handleDelete);
      }
    };
  }, [type]);

  useEffect(() => {
    const copyButtonIcon = copyButtonIconRef.current;
    if (copyButtonIcon) {
      copyButtonIcon.addEventListener("click", handleCopyIcon);
    }
  }, [copyButtonIconRef.current]);

  const handleDelete = () => {
    swal.close();
    onDelete();
  };

  const handleClose = () => {
    swal.close();
  };
  const handleNo = () => {
    onCancel();
  };

  const handleClick = () => {
    if (type === "copy") {
      onClick();
      setShowCopiedButtonLabel(true);
      setTimeout(() => {
        setShowCopiedButtonLabel(false);
        swal.close();
      }, 2000);
    } else {
      swal.close();
      onClick();
    }
  };

  const handleCancel = () => {
    swal.close();
    onCancel();
  };

  const handleCopyIcon = () => {
    onClick();
    setShowCopyTooltip(true);
  };

  const checkingType = () => {
    if (type === "delete") {
      return (
        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            ref={closeButtonRef}
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 hover:ring-gray-300 sm:col-start-1 sm:mt-0 custom-cancel-button"
          >
            Cancel
          </button>
          <button
            type="button"
            ref={deleteButtonRef}
            className="inline-flex w-full justify-center rounded-md !bg-rose-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:!bg-rose-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600 sm:col-start-2 custome-delete-button"
          >
            {buttonText ? buttonText : "Delete"}
          </button>
        </div>
      );
    } else if (type === "confirm") {
      return (
        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            ref={closeButtonRef}
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 hover:ring-gray-300 sm:col-start-1 sm:mt-0 custom-cancel-button"
          >
            {buttonText === "Yes" ? "No" : "Cancel"}
          </button>
          <button
            type="button"
            ref={confirmButtonRef}
            className="inline-flex w-full justify-center rounded-md !bg-[--bg-color-500] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:!bg-[--bg-color-600] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[--bg-color-600] sm:col-start-2 custome-delete-button"
          >
            {buttonText ? buttonText : "Delete"}
          </button>
        </div>
      );
    } else if (type === "copy") {
      return (
        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            ref={closeButtonRef}
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 hover:ring-gray-300 sm:col-start-1 sm:mt-0 custom-cancel-button"
          >
            Cancel
          </button>
          <button
            type="button"
            ref={copyButtonRef}
            className="inline-flex w-full justify-center rounded-md !bg-[--bg-color-500] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:!bg-[--bg-color-600] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[--bg-color-600] sm:col-start-2 custome-delete-button"
          >
            {buttonText
              ? !showCopiedButtonLabel
                ? buttonText
                : "Copied"
              : "Copy"}
          </button>
        </div>
      );
    } else {
      return (
        <div className="mt-5 sm:mt-6 flex justify-between xyz">
          <button
            type="button"
            id="okButton"
            ref={okButtonRef}
            className="grow-1 inline-flex w-full justify-center rounded-md !bg-[--bg-color-500] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:!bg-[--bg-color-600] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[--bg-color-600] sm:col-start-2 custom-ok-button"
          >
            Ok
          </button>
        </div>
      );
    }
  };

  const Icons = () => {
    switch (type) {
      case "success":
        return (
          <span className="far fa-check-circle fill-current text-3xl text-green-400"></span>
        );
        break;
      case "error":
        return (
          <span className="far fa-exclamation-triangle fill-current text-3xl text-rose-400"></span>
        );
        break;
      case "delete":
        return (
          <span className="far fa-exclamation-triangle fill-current text-3xl text-rose-400"></span>
        );
        break;
      case "warning":
        return (
          <span className="far fa-exclamation-triangle fill-current text-3xl text-yellow-400"></span>
        );
        break;
      case "info":
        return (
          <span className="far fa-info-circle fill-current text-3xl text-blue-400"></span>
        );
      case "confirm":
        return (
          <span className="far fa-exclamation-triangle fill-current text-3xl text-yellow-400"></span>
        );
        break;
      case "copy":
        return (
          <span className="far fa-check-circle fill-current text-3xl text-green-400"></span>
        );
        break;
      default:
        break;
    }
  };

  const renderSuccessCopyModalContent = () => {
    return (
      <>
        <span style={{ fontSize: "13px" }}>
          You have successfully added a access token. Copy the token now
        </span>
        <div className="flex items-center space-x-4 space-y-3 pb-6">
          <InputField
            type="text"
            label=""
            wrapperClass=" w-10/12"
            value={content}
            disabled
          />
          <Tippy
            content={showCopyTooltip ? "Copied" : "Copy"}
            zIndex={99999}
            key={showCopyTooltip ? "Copied" : "Copy"}
          >
            <button
              type="button"
              class="fa-solid fa-copy transform -translate-y-1/2"
              style={{
                color: "#94A3B8",
                fontSize: "22px",
                marginRight: "45px",
              }}
              ref={copyButtonIconRef}
              id="copyToken"
            ></button>
          </Tippy>
        </div>
        <Pageinfo
          type="info"
          title="Warning - Make sure you copy the above token now."
          message={`We don't store it and you will not be able to see it again`}
          open={true}
          close={false}
        />
      </>
    );
  };

  
  let styleVars = {};
  const { palettes: { color_palettes }} = store.getState();

  if(color_palettes){
    styleVars = Object.keys(color_palettes).reduce((acc, shade) => {
      acc[`--bg-color-${shade}`] = color_palettes[shade];
      return acc;
    }, {});
  }

  return (
    <div className="p-2"
      style={{
        ...styleVars
      }}
    >
      <div>
        <div
          className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${
            (type === "success" || type === "copy") && "bg-green-100"
          } ${type === "error" && "bg-rose-100"} ${
            type === "warning" && "bg-yellow-100"
          } ${type === "info" && "bg-blue-100"} ${
            type === "delete" && "bg-rose-100"
          } ${type === "confirm" && "bg-yellow-100"} `}
        >
          {Icons()}
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            {title}
          </h3>
          <div className="mt-2">
            {type === "copy" ? (
              renderSuccessCopyModalContent()
            ) : (
              <div className="text-sm text-gray-500">{content}</div>
            )}
          </div>
        </div>
      </div>
      {checkingType()}
    </div>
  );
}

export default CustomeModal;
